import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
// Suvidha AI design system — self-hosted fonts + icons (bundled, so the offline PWA keeps them; no CDN).
import '@fontsource/hanken-grotesk/400.css';
import '@fontsource/hanken-grotesk/500.css';
import '@fontsource/hanken-grotesk/600.css';
import '@fontsource/hanken-grotesk/700.css';
import '@fontsource/hanken-grotesk/800.css';
import '@fontsource/mukta/400.css';
import '@fontsource/mukta/500.css';
import '@fontsource/mukta/600.css';
import '@fontsource/mukta/700.css';
import '@fontsource/mukta/800.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import '@fontsource/ibm-plex-mono/600.css';
import '@phosphor-icons/web/regular';
import '@phosphor-icons/web/fill';
import App from './App';

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    sendDefaultPii: false,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    const hadController = Boolean(navigator.serviceWorker.controller);
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (hadController && !refreshing) { refreshing = true; document.dispatchEvent(new CustomEvent('app-update-available')); }
    });
    navigator.serviceWorker
      .register('/sw.js', { updateViaCache: 'none' })
      .then((reg) => { reg.update(); })
      .catch((err) => { console.warn('Service worker registration failed:', err); });
  });
}

if (process.env.NODE_ENV === 'production') {
  let _buildId = null;
  let _reloading = false;
  async function checkVersion() {
    if (_reloading) return;
    try {
      const res = await fetch(`/version.json?ts=${Date.now()}`, { cache: 'no-store' });
      if (!res.ok) return;
      const { buildId } = await res.json();
      if (!_buildId) { _buildId = buildId; return; }
      if (_buildId !== buildId) { _reloading = true; document.dispatchEvent(new CustomEvent('app-update-available')); }
    } catch (_) {}
  }
  checkVersion();
  window.addEventListener('focus', checkVersion);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) checkVersion(); });
  window.addEventListener('online', checkVersion);
  setInterval(checkVersion, 5 * 60 * 1000);
}
